<div class="container-fluid" id="etp-list">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-2">
        <div class="tile">
          <div class="row">
            <div class="col-12">
              <h1 class="zero-text p-huge-med">
                {{ 'crypto.overview.etp_headline' | transloco }}
              </h1>
              <p class="mt-4">{{ 'crypto.overview.etp_hint' | transloco }}</p>
            </div>
          </div>
          <table class="table-depot" aria-describedby="etp-list">
            <thead>
              <tr class="etp-header">
                <th>
                  {{ 'crypto.overview.name' | transloco }}
                </th>
                <th>
                  {{ 'crypto.overview.staking-reward.label' | transloco }}
                  <div class="icon-tooltip-wrapper">
                    <svg class="icon icon-16 cursor-pointer" (click)="showStakingRewardModal(stakingRewardModal)">
                      <use xlink:href="/assets/img/svgs/svgset.svg#info" />
                    </svg>
                  </div>
                </th>
                <th>{{ 'crypto.overview.wkn' | transloco }}</th>
                <th>{{ 'crypto.overview.quote' | transloco }}</th>
                <th>{{ 'crypto.overview.perf' | transloco }}</th>
                <th>
                  {{ 'crypto.overview.time' | transloco }}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (items) {
                @for (group of items; track $index) {
                  <tr class="group-header">
                    <td class="font-medium no-default-padding" colspan="7">
                      {{ group.name }}
                    </td>
                  </tr>
                  @for (etp of group.etps; track $index) {
                    <tr crypto-etp-list-item [etp]="etp" (showStakingRewardModal)="showStakingRewardModal(stakingRewardModal)"></tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #stakingRewardModal let-modal>
  <web-design-system-modal (dismiss)="modal.dismiss('Cross click')">
    <p [innerHTML]="'crypto.overview.staking-reward.modal.text' | transloco"></p>
  </web-design-system-modal>
</ng-template>
